import React from 'react';
import SarasDrawerMenu from '../../repeater/menu/SarasDrawerMenu';

const SarasSideBar =(props)=>{
    return(
        <SarasDrawerMenu />
    )
}

export default SarasSideBar